import usePageMeta from "@/hooks/usePageMeta";
import SiteLayout from "@/components/feature/SiteLayout";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryShortcuts from "@/pages/home/components/CategoryShortcuts";
import LatestAnime from "@/pages/home/components/LatestAnime";
import HotRanking from "@/pages/home/components/HotRanking";
import NewsPreview from "@/pages/home/components/NewsPreview";
import AboutPreview from "@/pages/home/components/AboutPreview";

export default function Home() {
  usePageMeta(
    "妖精动漫-最新热门动漫在线观看与资讯平台",
    "妖精动漫提供丰富的动漫内容，包括最新热门动漫观看、详细动漫资讯和动漫推荐，满足动画爱好者的多样化需求。"
  );

  return (
    <SiteLayout>
      <h1 className="sr-only">妖精动漫 - 最新热门动漫观看与动漫资讯平台</h1>
      <HeroCarousel />
      <CategoryShortcuts />
      <LatestAnime />
      <HotRanking />
      <NewsPreview />
      <AboutPreview />
    </SiteLayout>
  );
}